var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMenuLogoutActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_13050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.69 21H4.22C3 21 2 19.99 2 18.74V5.26C2 4.01 2.99 3 4.22 3H13.7C14.92 3 15.92 4.01 15.92 5.26V7.14C15.92 7.57 15.58 7.91 15.16 7.91C14.74 7.91 14.4 7.56 14.4 7.14V5.26C14.4 4.87 14.09 4.55 13.7 4.55H4.22C3.83 4.55 3.52 4.87 3.52 5.26V18.74C3.52 19.13 3.83 19.45 4.22 19.45H13.7C14.09 19.45 14.4 19.13 14.4 18.74V16.78C14.4 16.35 14.74 16.01 15.16 16.01C15.58 16.01 15.92 16.36 15.92 16.78V18.74C15.92 19.98 14.92 21 13.7 21H13.69Z",
    fill: "#242628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3202 16C18.1302 16 17.9302 15.92 17.7802 15.77C17.4802 15.47 17.4802 14.98 17.7802 14.68L20.4102 12L17.7802 9.32001C17.4802 9.02 17.4802 8.53 17.7802 8.23C18.0802 7.93 18.5602 7.93 18.8502 8.23L22.0202 11.45C22.3202 11.75 22.3202 12.24 22.0202 12.54L18.8502 15.76C18.7002 15.91 18.5102 15.99 18.3102 15.99L18.3202 16Z",
    fill: "#242628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4202 11.23H21.4902C21.9102 11.23 22.2502 11.58 22.2502 12C22.2502 12.42 21.9102 12.77 21.4902 12.77H9.50023C9.08023 12.77 8.74023 12.42 8.74023 12C8.74023 11.58 9.08023 11.23 9.50023 11.23H20.4202Z",
    fill: "#242628"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_13050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.25,
    height: 18,
    fill: "white",
    transform: "translate(2 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMenuLogoutActive);
export default __webpack_public_path__ + "static/media/ico-menu-logout-active.812321725635b2260ed08120a8486551.svg";
export { ForwardRef as ReactComponent };